//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-left-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/features2.svg';

var ProductsCarousel = () => import('~/components/organisms/Global/ProductsCarousel.vue');

export default {
  components: {
    ProductsCarousel
  },
  props: {
    image: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    reference: {
      type: String,
      default: null
    }
  }
};